import { render, staticRenderFns } from "./SnowCheckbox.vue?vue&type=template&id=f8a15c36&scoped=true&"
import script from "./SnowCheckbox.vue?vue&type=script&lang=js&"
export * from "./SnowCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./SnowCheckbox.vue?vue&type=style&index=0&id=f8a15c36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a15c36",
  null
  
)

export default component.exports